export const ACTIONS = {
  LIST_SUPPLIERS: 'SERVICE_SUPPLIERS__LIST_SUPPLIERS',
  ADD_SUPPLIER: 'SERVICE_SUPPLIERS__ADD_SUPPLIER',
  UPDATE_SUPPLIER: 'SERVICE_SUPPLIERS__UPDATE_SUPPLIER',
  DELETE_SUPPLIER: 'SERVICE_SUPPLIERS__DELETE_SUPPLIER',
};
